import type { ScaleType, NoteName } from '@tunasong/schemas'
import { MODE_NAMES } from './mode.js'
import { ALL_SCALES } from './scale.js'

export interface Key {
  root: NoteName
  type?: ScaleType // major is implied
}

/** The common scale names. We omit the theoretical ones - e.g., A# */
export const scaleNoteNames: NoteName[] = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B']

export type KeyNameType = 'all' | 'mode' | 'common' | 'simple'

/** Get the key names in  */
export const getKeyNames = (type: KeyNameType): ScaleType[] => {
  const modes = MODE_NAMES
  if (type === 'mode') {
    return modes
  } else if (type === 'simple') {
    return ['major', 'minor']
  } else if (type === 'common') {
    return ALL_SCALES.filter(m => m !== 'ionian' && m !== 'aeolian')
  }
  return ALL_SCALES
}
